const TMDB_KEY = process.env.REACT_APP_TMDB_API_KEY;

export async function searchTMDBTV(title, year) {
  if (!TMDB_KEY || !title) return null;

  const params = new URLSearchParams({
    api_key: TMDB_KEY,
    query: title,
    include_adult: "false",
    language: "en-US",
  });

  if (year) params.set("first_air_date_year", String(year));

  const res = await fetch(`https://api.themoviedb.org/3/search/tv?${params}`);
  if (!res.ok) return null;

  const json = await res.json();
  return json.results?.[0] || null;
}

export async function searchTMDBMovie(title, year) {
  if (!TMDB_KEY || !title) return null;

  const params = new URLSearchParams({
    api_key: TMDB_KEY,
    query: title,
    include_adult: "false",
    language: "en-US",
  });

  if (year) params.set("year", String(year));

  const res = await fetch(`https://api.themoviedb.org/3/search/movie?${params}`);
  if (!res.ok) return null;

  const json = await res.json();
  return json.results?.[0] || null;
}

export async function getTMDBWatchProviders(tmdbId, mediaType = "movie", region = "US") {
  if (!TMDB_KEY || !tmdbId) return [];

  const type = mediaType === "tv" || mediaType === "show" ? "tv" : "movie";

  const res = await fetch(
    `https://api.themoviedb.org/3/${type}/${tmdbId}/watch/providers?api_key=${TMDB_KEY}`
  );

  if (!res.ok) return [];

  const json = await res.json();
  const regionData = json.results?.[region];

  const providers = [
    ...(regionData?.flatrate || []),
    ...(regionData?.rent || []),
    ...(regionData?.buy || []),
  ];

  const seen = new Set();

  return providers
    .filter((provider) => {
      if (seen.has(provider.provider_id)) return false;
      seen.add(provider.provider_id);
      return true;
    })
    .map((provider) => ({
      id: provider.provider_id,
      name: provider.provider_name,
      logo: tmdbImage(provider.logo_path, "w92"),
    }));
}

export async function getTMDBBrandLogo(tmdbId, mediaType = "movie") {
  if (!TMDB_KEY || !tmdbId) return null;

  const type = mediaType === "tv" || mediaType === "show" ? "tv" : "movie";

  const res = await fetch(
    `https://api.themoviedb.org/3/${type}/${tmdbId}?api_key=${TMDB_KEY}`
  );

  if (!res.ok) return null;

  const json = await res.json();

  const brand =
    type === "tv"
      ? json.networks?.find((n) => n.logo_path)
      : json.production_companies?.find((c) => c.logo_path);

  if (!brand) return null;

  return {
    id: brand.id,
    name: brand.name,
    logo: tmdbImage(brand.logo_path, "w154"),
  };
}

export function tmdbImage(path, size = "w780") {
  if (!path) return null;
  return `https://image.tmdb.org/t/p/${size}${path}`;
}
